import Vue from 'vue';
import Buefy from 'buefy';
import Sticky from 'vue-sticky-directive';
import VeeValidate from 'vee-validate';
import VueParallax from 'vue-parallax-js';
import VueScrollReveal from 'vue-scroll-reveal';
import VueScrollTo from 'vue-scrollto';
import '@fortawesome/fontawesome-pro/css/all.css';
import App from '@/App.vue';
import CloudinaryImage from '@/components/CloudinaryImage.vue';
import router from '@/router';
import store from '@/store';
import '@/utils/filters';

// import { Auth0Plugin } from './auth';

Vue.use(Buefy, {
  defaultIconPack: 'fal',
});
Vue.use(Sticky);
Vue.use(VeeValidate);
Vue.use(VueParallax, {
  minWidth: 769,
});
Vue.use(VueScrollReveal);
Vue.use(VueScrollTo);
Vue.component('cl-img', CloudinaryImage);

// Vue.use(Auth0Plugin, {
//   domain: process.env.VUE_APP_AUTH0_DOMAIN,
//   clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
//   onRedirectCallback: appState => {
//     router.push(
//       appState && appState.targetUrl
//         ? appState.targetUrl
//         : window.location.pathname
//     );
//   }
// });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
